import klachtenApi from "../../api/klachtenApi";
import mergeDeep from "../../util/mergeDeep";
import generateGuid from "../../util/guid";
import FilesHelper from "../common/FilesHelper";
import moment from "moment";

export default class ExterneKlachtenPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const klachtId = generateGuid();
        this.context.filesHelper = new FilesHelper(this.context, null);

        let model = mergeDeep({}, this.context.state.klachtenModel);
        model.id = klachtId;
        model.datum = moment().format("DD-MM-YYYY");

        this.context.setState({
            klachtenModel: model
        });
    }

    change(event) {
        const property = event.target.name;
        const value = event.target.value;

        let model = mergeDeep({}, this.context.state.klachtenModel);
        model[property] = value;

        this.context.setState({
            klachtenModel: model
        });
    }

	saveAdres(adres) {
		let model = mergeDeep({}, this.context.state.klachtenModel);
		model.adres = adres;

		this.context.setState({
			klachtenModel: model
		});
	}

    addBijlage(event) {
        const currentBijlages = this.context.state.klachtenBijlage;
        const value = event.target.value;
        const toAddItems = [];
        value.forEach(file => {
            if (!this.context.filesHelper.checkIsValidFile(file)) return;

            if (!currentBijlages.length || !currentBijlages.find(x => x.name === file.name)) {
                toAddItems.push(file);
                currentBijlages.push(file);
            }
        });

        this.context.setState({
            klachtenBijlage: currentBijlages,
            hasUnsavedDocumentChanges: true
        });

        if (!this.context.filesHelper.ownerId) {
            this.context.filesHelper.setOwnerId(this.context.state.klachtenModel.id).then(response => {
                this.context.filesHelper.uploadFiles("klachtenBijlage", toAddItems);
            });
        }
        else {
            this.context.filesHelper.uploadFiles("klachtenBijlage", toAddItems);
        }
    }

    removeBijlage(event) {
        const value = event.target.value;
        const currentBijlages = this.context.state.klachtenBijlage;
        const toRemoveItem = currentBijlages.find(x => value.indexOf(x) === -1);

        this.context.setState({
            klachtenBijlage: value,
            hasUnsavedDocumentChanges: true
        });

        if (toRemoveItem) this.context.filesHelper.deleteOneFile("klachtenBijlage", toRemoveItem.name);
    }

    save() {
        const context = this.context;
        const state = context.state;
        const ajaxActions = context.props.ajaxActions;

        let modelToSave = state.klachtenModel;
        let documentsForSave = state.klachtenBijlage;

        ajaxActions.started();
        return klachtenApi.saveExterneKlacht(modelToSave, documentsForSave)
            .then((response) => {
                ajaxActions.ended();

                if (Object.keys(response.data.validationResults).length === 0 && response.data.hasValidationErrors === false) {
                    context.filesHelper.commitSession();
                }

                this.context.setState({
                    errors: response.data.validationResults,
                    klachtSent: !response.data.hasValidationErrors
                });
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

	onCaptchaVerified(verified) {
		this.context.setState({
			sendButtonDisabled: !verified
		});
	}
}
